export default __webpack_public_path__ + "static/media/basketball-player-multicolor@2x.19090aa8.png";